import React from 'react';
import propTypes from 'prop-types';

import {
  TranslatedLinkMessage,
  TranslatedMessage,
} from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';
import StarRating from 'apps/cart/components/StarRating';

const QuickShopProductInformation = props => {
  const {
    productDisplayPage,
    reviewsElementId,
    showDescription,
    showDetailsLink,
    variant,
  } = props;

  const HeadingTag = productDisplayPage ? `h1` : `h3`;
  const disclaimerKey = variant.hasJ2NicotineStrength
    ? 'cart.quick_shop.pod_contents_disclaimer_j2'
    : 'cart.quick_shop.pod_contents_disclaimer';

  return (
    <div className="product-information">
      <div className="product-information__header">
        <div className="product-information__header__title">
          <HeadingTag className="product-information__header__title__name heading--title--medium">
            {variant.name}
          </HeadingTag>

          {!!variant.productScore && !!variant.totalReviews && (
            <div className="product-information__header__title__rating">
              <StarRating
                value={variant.productScore}
                count={variant.totalReviews}
                scrollElementId={reviewsElementId}
              />
            </div>
          )}

          {showDetailsLink && (
            <a className="quickShop__details-link" href={variant.url}>
              <TranslatedMessage id={'cart.quick_shop.see_full_details'} />
            </a>
          )}
        </div>

        {productDisplayPage && (
          <span className="product-information__header__price">
            <span className="product-information__header__price__display heading--title--medium">
              {variant.retailExclusive !== true && (
                <PriceSpan amount={variant.price} />
              )}
            </span>
          </span>
        )}
      </div>

      {showDescription && (
        <div className="product-information__description product-information__description--has-quick-shop">
          <p>{variant.description}</p>

          <p>
            <TranslatedMessage
              id={disclaimerKey}
              values={{
                nicotinePercent: variant.nicotineStrength,
              }}
            />
          </p>
          {variant.hasJ2NicotineStrength && (
            <p>
              <TranslatedLinkMessage
                id={'page.products.learn_new_pods_tech'}
                linkText={'page.products.learn_new_pods_tech_link_text'}
                link={'page.products.learn_new_pods_tech_link'}
              />
            </p>
          )}
        </div>
      )}
    </div>
  );
};

QuickShopProductInformation.propTypes = {
  productDisplayPage: propTypes.bool.isRequired,
  reviewsElementId: propTypes.string,
  showDescription: propTypes.bool.isRequired,
  showDetailsLink: propTypes.bool.isRequired,
  variant: propTypes.shape({
    description: propTypes.string.isRequired,
    flavor: propTypes.string.isRequired,
    name: propTypes.string.isRequired,
    nicotineStrength: propTypes.string.isRequired,
    price: propTypes.number.isRequired,
    productScore: propTypes.number,
    totalReviews: propTypes.number,
    url: propTypes.string.isRequired,
  }),
};

export default QuickShopProductInformation;
